"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typedi_1 = require("typedi");
function getLocationSearch() {
    if (typeof window !== 'undefined' && window.location && window.location.search) {
        return window.location.search;
    }
    return '';
}
function defaultHeadersResolver(context, debug, locationSearchResolver) {
    if (locationSearchResolver === void 0) { locationSearchResolver = getLocationSearch; }
    var authToken = (context || {}).authToken;
    var token = typeof authToken === 'function' ? authToken() : authToken;
    var headers = {};
    if (token) {
        headers.Authorization = "Bearer " + token;
    }
    var debugMode = !!debug;
    var locationSearch = typeof locationSearchResolver === 'function' ? locationSearchResolver() : undefined;
    if (locationSearch) {
        debugMode = /[?&]debug=(true|1)/i.test(locationSearch);
    }
    var instance = typedi_1.Container.get('instance');
    var result = __assign(__assign({}, headers), { Accept: 'application/json', 'Content-Type': 'application/json', SeismicClientName: instance.helper.getClientType() });
    if (debugMode) {
        result.debug = true;
    }
    return result;
}
exports.default = defaultHeadersResolver;
//# sourceMappingURL=defaultHeadersResolver.js.map